import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const changeTrainingFollowUpEndDate = createAsyncThunk<
  void,
  { trainingFollowUpId: string; endDate: Date },
  { extra: Partial<Dependencies> }
>("trainingFollowUps/changeTrainingFollowUpEndDate", async ({ trainingFollowUpId, endDate }, { extra: { adminRepository } }) => {
  return adminRepository!.changeTrainingFollowUpEndDate({ trainingFollowUpId, endDate });
});
